// extracted by mini-css-extract-plugin
module.exports = {"container":"Calculation_container__3p-hs","header":"Calculation_header__KrjWI","spinner":"Calculation_spinner__237lE","subheader":"Calculation_subheader__3fe0p"};